import jQuery from 'jquery';
import Popper from 'popper.js';

window.$ = window.jQuery = jQuery;
window.Popper = Popper;
